import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoAuthGuard } from 'app/core/guards/no-auth.guard';
/** Pre-login / empty-layout routes (NoAuthGuard). */
export const guestRoutes: Route = {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
        layout: 'empty',
    },
    children: [
        {
            path: 'confirmation-required',
            loadChildren: () =>
                import(
                    'app/features/auth/confirmation-required/confirmation-required.routes'
                ),
        },
        {
            path: 'forgot-password',
            loadChildren: () =>
                import(
                    'app/features/auth/forgot-password/forgot-password.routes'
                ),
        },
        {
            path: 'reset-password',
            loadChildren: () =>
                import(
                    'app/features/auth/reset-password/reset-password.routes'
                ),
        },
        {
            path: 'sign-in',
            loadChildren: () =>
                import('app/features/auth/sign-in/sign-in.routes'),
        },
        {
            path: 'sign-out',
            loadChildren: () =>
                import('app/features/auth/sign-out/sign-out.routes'),
        },
        {
            path: 'sign-up',
            loadChildren: () =>
                import('app/features/auth/sign-up/sign-up.routes'),
        },
        {
            path: 'auth/google/callback',
            loadChildren: () =>
                import(
                    'app/features/auth/google-callback/google-callback.routes'
                ),
        },
        {
            path: 'contact',
            loadChildren: () =>
                import('app/features/public/contact/contact.routes'),
        },
        {
            path: 'public',
            loadChildren: () => import('app/features/public/public.routes'),
            data: {
                layout: 'empty',
            },
        },
        {
            // Album access-grant entry: `/p/{code}` → session → /public/albums/:id.
            path: 'p/:code',
            loadChildren: () =>
                import('app/features/public/grant-entry/grant-entry.routes'),
            data: {
                layout: 'empty',
            },
        },
        {
            path: 'landing',
            loadChildren: () =>
                import('app/features/public/landing/landing.routes'),
            data: {
                layout: 'empty',
            },
        },
    ],
};
